
import {default as Group, Controller as GroupController} from './../../../zviz2/zviz/components/group';
import TextBox from './../../../zviz2/zviz/components/svg/textbox';
import Rectangle from './../../../zviz2/zviz/components/rectangle';
import SvgWrapper from './../../../zviz2/zviz/components/svg/wrapper';

import {styleH4, styleSubtitle, styleText, styleNumber, styleNumberSmall} from './../../../styles';
import config from './../../../config';
import {formatNumber} from './../../../tools';
import {extend, cloneObject, rgbToHsl, hslToRgb} from './../../../zviz2/zviz/functions';
import state from './../../../zviz2/zviz/state';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
    
        this.resetGraph = true;

        this.hasX2 = false;
        this.scale = 1;
        this.gridSizeVal = 1;

        this.height = 0;
        this.width = 0;
        this.right = 0;
        this.left = 0;

        this.titleHeight = 30;
        this.marginTop = 50;
        this.legendHeight = 0;
        this.colors = [[50,50,50]];

    }

    setup(){

        this.height = this.data.height - this.data.settings.margin.top - this.data.settings.margin.bottom;
        this.width = this.data.width - this.data.settings.margin.left - this.data.settings.margin.right;

        let maxY = 0;
        this.hasX2 = false;

        let values = this.data.settings.y || [];
        for(let i = 0; i <= values.length; i++){
            if(values[i]){
                let y = parseFloat(values[i]);
                if(y > maxY){
                    maxY = y;
                }
            }
        }
        
        if(this.getDistinctX2().length > 0){
            this.hasX2 = true;
        }

        this.gridSizeVal = this.gridSize(maxY);

        this.scale = (maxY==0)? 1: this.width / maxY;


        if(this.hasX2){
            let X2vals = this.getDistinctX2();
            let range = Math.min(0.7, 0.2*X2vals.length);
            let rgb = this.data.settings.color;
            let hsl = rgbToHsl(rgb);
            let start = 0.5;
            let stop = 0.7;
            if(hsl[2] + 0.5 * range > 0.8){
                stop = 0.8;
                start = 0.8 - range;
            }else if(hsl[2] - 0.5 * range < 0.2){
                start = 0.2;
                stop = 0.2 + range;
            }else{
                start = hsl[2] - 0.5 * range;
                stop = hsl[2] + 0.5 * range;
            }
            this.colors = [];
            let step = range / X2vals.length;
            for(let i = 0; i < X2vals.length; i++){
                this.colors.push(hslToRgb([360*hsl[0], 100*hsl[1], 100*(start+i*step)]));
            }
        }else{
            this.colors = [ this.data.settings.color ];
        }

    }

    getDistinctX2(){
        let values = [];
        for(let i = 0; i < this.data.settings.x2.length; i++){
            if(this.data.settings.x2[i] && values.indexOf(this.data.settings.x2[i]) == -1){
                values.push(this.data.settings.x2[i]);
            }
        }
        return values;
    }

    getDistinctX1(){
        let values = [];
        for(let i = 0; i < this.data.settings.x1.length; i++){
            if(this.data.settings.x1[i] && values.indexOf(this.data.settings.x1[i]) == -1){
                values.push(this.data.settings.x1[i]);
            }
        }
        return values;
    }


    gridSize(max){
        return max;
        // if(max == 0){
        //     return 0;
        // }
        // let step = max / this.data.settings.gridLines;
		// let factor = 1;
		// while(step > 10){
		// 	step = step / 10;
		// 	factor *= 10;
		// }
		
		// return factor * Math.floor(step*2)/2;
    }

    getAxis(){

        // the x-axis
        let result = [
            extend({
                properties: {
                    style: {
                        stroke: '#565656',
                        strokeWidth: '0.6px'
                    },
                    attributes: {
                        d: 'M' + -0.5*this.left + ',0 L'+ (this.width + 0.5*this.right) + ',0'
                    }
                }  
            }, Path)
        ];

        for(let i = 1; i <= this.data.settings.gridLines; i++){
            let top = -i * this.gridSizeBudget * this.budgetScale;

            // grid line
            result.push(extend({
                properties: {
                    style: {
                        stroke: '#E2E2E2',
                        strokeWidth: '0.6px'
                    },
                    attributes: {
                        d: 'M0,' + top + ' L'+ this.width + ',' + top
                    }
                }  
            }, Path) );

            if(this.hasBudget){
                // marker budget
                result.push(extend({
                    properties: {
                        style: {
                            stroke: 'none',
                            fill: this.colors['budget']
                        },
                        attributes: {
                            d: 'M'+(this.width-12)+','+(top-6)+' L'+ this.width + ',' + (top+6) + ' L'+ (this.width-12) + ',' + (top+6) + 'Z'
                        }
                    }  
                }, Path));
                // marker expenditure
                result.push(extend({
                    properties: {
                        style: {
                            stroke: 'none',
                            fill: this.colors['expenditure']
                        },
                        attributes: {
                            d: 'M'+(this.width-12)+','+(top-6)+' L'+ this.width + ',' + (top-6) + ' L'+ this.width + ',' + (top+6) + 'Z'
                        }
                    }  
                }, Path));
            }else{
                // marker for only expenditure
                result.push(extend({
                    properties: {
                        style: {
                            stroke: 'none',
                            fill: this.colors['expenditure']
                        },
                        attributes: {
                            d: 'M'+(this.width-12)+','+(top-6)+' L'+ this.width + ',' + (top-6) + ' L'+ this.width + ',' + (top+6) + ' L' + (this.width-12)+','+ (top+6) + 'Z'
                        }
                    }  
                }, Path));
            }

            //marker projects
            if(this.hasProjects){
                result.push(extend({
                    properties: {
                        style: {
                            fill: this.colors['project']
                        },
                        attributes: {
                            cx: 6,
                            cy: top,
                            r: 6
                        }
                    }
                }, Arc));
            }

            // right label (budget) for gridline
            if(state.get('renderSize') != 'small' || i == this.data.settings.gridLines){
                let x = this.width + 5;
                let y = top + 5;
                let align = 'left';
                let w = this.right;
                if(state.get('renderSize') == 'small'){
                    x = this.width - 100;
                    y = top - 10;
                    align = 'right';
                    w = 100;
                }

                result.push(extend({
                    properties: {
                        style: cloneObject(styleGraphLabel),
                        transform: {
                            position: {
                                x: x,
                                y: y,
                            }
                        },
                        data: {
                            width: w,
                            alignment: align,
                            text: formatNumber(i * this.gridSizeBudget, this.data.settings.language)
                        }
                    }  
                }, TextBox));

                // left label (project) for gridline
                if(this.hasProjects){
                    let projLabel = formatNumber(i * this.gridSizeProject, this.data.settings.language) + ' project';
                    if(state.get('renderSize') != 'small'){
                        x = -1*this.left;
                        align = 'right';
                        w = this.left - 5;
                    }else{
                        x = this.left;
                        align = 'left';
                        w = 100;
                    }
                    result.push(extend({
                        properties: {
                            style: cloneObject(styleGraphLabel),
                            transform: {
                                position: {
                                    x: x,
                                    y: y
                                }
                            },
                            data: {
                                width: w,
                                alignment: align,
                                text: projLabel
                            }
                        }  
                    }, TextBox));
                }
            }
        }

        // values on the x-axis
        let left = 0; // 0.5 * this.colWidth;
        let rotation = 0;
        let dy = 0;
        if(state.get('renderSize') == 'small'){
            rotation = 75 * Math.PI/180;
            dy = -12;
        }
        for(let y = this.range[0]; y <= this.range[1]; y++){ 
            result.push(extend({
                properties: {
                    style: cloneObject(styleGraphLabel),
                    transform: {
                        position: {
                            x: left,
                            y: 20+dy
                        },
                        rotation: rotation
                    },
                    data: {
                        width: this.colWidth,
                        text: y,
                        alignment: 'center',
                    }
                }  
            }, TextBox));
            left += this.colWidth;
        }

        return result;

    }

    setTitleHeight(value){
        this.titleHeight = value;
        this.update();
    }
    setSubtitleHeight(value){
        this.marginTop = this.titleHeight + 20 + value;
        this.update();
    }

    getTitle(){
        let title = this.data.settings.dimension[2] || '';
        let subtitle = this.data.settings.unit[2] || '';
        if(! title){
            this.marginTop = 0;
            return [];
        }
        return [
            extend({
                properties: {
                    style: extend({ }, styleH4),
                    transform: {
                        position: {
                            x: 0,
                            y: 30
                        }
                    },
                    data: {
                        width: this.width,
                        text: title,
                        alignment: 'left',
                        height: 90,
                        lineHeight: 25
                    }
                },
                responders: [
                    {name: 'textHeight', callback: [this, this.setTitleHeight] },
                ]
            }, TextBox),
            
            extend({
                properties: {
                    style: extend({ }, styleSubtitle),
                    transform: {
                        position: {
                            x: 0,
                            y: this.titleHeight + 25
                        }
                    },
                    data: {
                        width: this.width,
                        text: subtitle,
                        alignment: 'left',
                        height: 40,
                        lineHeight: 20
                    },
                },
                responders: [
                    {name: 'textHeight', callback: [this, this.setSubtitleHeight] },
                ]
            }, TextBox)
        ];
    }

    getLegend(){

        if(! this.hasX2){
            return [];
        }

        let result = [];

        let labels = this.getDistinctX2();
        
        let title = this.data.settings.dimension[1];
        if(this.data.settings.unit[1]){
            title += ' (' +this.data.settings.unit[1] +')';
        }

        let top = this.marginTop;

        result.push(extend({
            properties: {
                style: extend({
                    fontWeight: 'bold'
                }, styleText),
                transform: {
                    position: {
                        x: 0,
                        y: top + 30
                    }
                },
                data: {
                    width: this.width + this.data.settings.margin.right,
                    text: title,
                    alignment: 'left',
                    height: 20,
                    lineHeight: 17
                }
            }  
        }, TextBox));

        top += 40;
        let i = 0;

        for(let label of labels){ 
            result.push(extend({
                properties: {
                    style: {
                        fill: 'rgb(' + this.colors[i].slice(0,3).join(',') + ')'
                    },
                    attributes: {
                        x: 0,
                        y: top,
                        width: 15,
                        height: 15
                    }
                }
            }, Rectangle));

            result.push(extend({
                properties: {
                    style: extend({
                    }, styleText),
                    transform: {
                        position: {
                            x: 20,
                            y: top + 12
                        }
                    },
                    data: {
                        width: this.width + this.data.settings.margin.right - 20,
                        text: label,
                        alignment: 'left',
                        height: 40,
                        lineHeight: 15
                    }
                }  
            }, TextBox));

            top += 30;
            i++;
            
        }

        this.legendHeight = top - this.marginTop + 20;

        return result;
    }

    findValue(x1, x2=false){
        for(let i = 0; i < this.data.settings.y.length; i++){
            if(x1 === this.data.settings.x1[i]){
                if(! x2 || x2 === this.data.settings.x2[i]){
                    return this.data.settings.y[i];
                }
            }
        }
        return '-';
    }

    getBars(){

        let result = [];

        let x1List = this.getDistinctX1();
        // let hasTarget = false;
        // for(let x of x1List){
        //     if((''+x).toLowerCase().indexOf('target')!=-1){
        //         hasTarget = true;
        //     }
        // }
        
        // if(! hasTarget){
        //     // x1List.reverse();
        // }

        let x2List = this.getDistinctX2();
        if(! this.hasX2){
            x2List = [false];
        }
        let values = this.data.settings.y;
        let bars = (this.hasX2)? x2List.length: 1;

        let duration = 500;
      
        let top = this.marginTop + this.legendHeight;
        for(let x = 0; x < x1List.length; x++){ 
            let x1 = x1List[x];
            result.push(extend({
                properties: {
                    style: extend({
                        fontSize: '10pt',
                        color: '#000000'
                    }, styleSubtitle),
                    transform: {
                        position: {
                            x: 0,
                            y: top + 15
                        }
                    },
                    data: {
                        width: this.width,
                        text: x1,
                        alignment: 'left',
                        height: 15,
                        lineHeight: 15
                    }
                }  
            }, TextBox));
            
            top += 20;

            for(let b = 0; b < x2List.length; b++){ 
                let x2 = x2List[b];
                let y = this.findValue(x1, x2);
                if(y == '-'){
                    continue;
                }

                let unit = (this.data.settings.unit[2])? ' ' + this.data.settings.unit[2] +'': '';
                let label = this.data.settings.dimension[2] || '';
                // if(this.data.settings.unit[2]){
                //     label += unit;
                // }
                let label2 = '';

                let x1l = (x1+'')
                x1l = x1l.length>1? x1l.substring(0,1).toLowerCase() + x1l.substring(1): x1l;
                let x2l = (x2+'');
                x2l = x2l.length>1? x2l.substring(0,1).toLowerCase() + x2l.substring(1): x2l;
                if(this.data.settings.language == 'english'){
                    label2 = 'For ' + x1l;
                    if(this.hasX2){
                        label2 += ' and ' + x2l;
                    }
                }else{
                    label2 = 'Voor ' + x1l;
                    if(this.hasX2){
                        label2 += ' en ' + x2l;
                    }
                }
                // let label2 = 'For ' + ((this.data.settings.unit[0] == 'year')? 'year': (this.data.settings.dimension[0] || '')) + ' ' + x1;
                // if(this.hasX2){
                //     label2 += ' and ' + (this.data.settings.dimension[1] || '') + ' ' + x2;
                // }

                let value = (y == '-')? [y]: formatNumber(parseFloat(y), this.data.settings.language).split(' ');
                let barValue = (y == '-')? 2: Math.max(2, parseFloat(y) * this.scale);
                
                result.push(extend({
                    properties: {
                        style: {
                            fill: 'rgb(' + this.colors[b].slice(0,3).join(',') + ')'
                        },
                        attributes: {
                            x: 0,
                            y: top,
                            width: barValue + ' => transition ' + duration + ' cubic 0',
                            height: 15,
                        },
                        data: {
                            label: label + '\n' + label2,
                            value: value.join(' ') + unit
                        }
                    },
                    events: {
                        mouseover: (event, ctrl) => {
                            state.set('tooltip', [ '*'+ctrl.data.value, ctrl.data.label]);
                        },
                        mouseout: (event, ctrl) => { state.set('tooltip', null); }
                    }
                }, Rectangle));

                result.push(extend({
                    properties: {
                        style: {
                            fill: 'rgb(' + this.colors[b].slice(0,3).join(',') + ')'
                        },
                        attributes: {
                            x: 0,
                            y: top + 16,
                            width: this.width,
                            height: 1,
                        },
                    }
                }, Rectangle));



                result.push(extend({
                    properties: {
                        style: extend({
                        }, styleNumber),
                        transform: {
                            position: {
                                x: this.width + 10,
                                y: (value.length == 1)? top + 15: top + 7
                            }
                        },
                        data: {
                            width: this.data.settings.margin.right - 10,
                            text: value[0],
                            alignment: 'left',
                            height: 35,
                            lineHeight: 35
                        }
                    }  
                }, TextBox));

                if(value.length > 1){
                    result.push(extend({
                        properties: {
                            style: extend({
                            }, styleNumberSmall),
                            transform: {
                                position: {
                                    x: this.width + 10,
                                    y: top + 25
                                }
                            },
                            data: {
                                width: this.data.settings.margin.right - 10,
                                text: value[1],
                                alignment: 'left',
                                height: 15,
                                lineHeight: 15
                            }
                        }  
                    }, TextBox));
                }

                top += 50;
            }
        }

        this.setHeight(top + 40);

        return result;
    }

    getChildren(){
        this.setup();
        let result = this.getTitle();
        result.push(...this.getLegend());
        let bars = this.getBars();
        result.push(...bars);

        return result;
    }

    getSize(type){
        return this.getByUid(this.data.svgUid).getSize(type);
    }

    setHeight(height){
        this.getByUid(this.data.svgUid).setHeight(height);
    }

} 



let Blueprint = SvgWrapper({
    type: Controller,
    properties: {
        data: {
            svgUid: '',
            width: (ctrl) => (ctrl.getSize('w') ), 
            height: (ctrl) => (ctrl.getSize('h') ),
            settings: {}
        }
    },
    
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'windowSize') ),
    ],
    children: [ 
        (ctrl) => ( ctrl.getChildren() )
    ]
}, {
    properties: {
        data: {
            color: [50,50,50],
            dimension: [''],
            unit: [''],
            x1: [],
            x2: [],
            y: [],
            language: 'english',
            margin: {
                top: 0,
                right: 125,
                left: 0,
                bottom: 0
            },
            height: 'auto'
        }
    }
});




export default Blueprint;
export {Controller, Blueprint};